module.exports = __webpack_public_path__ + "img/download_ios.9bcf34e4.png";